'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { useRef, useState, useEffect } from 'react';
import { TextFieldContainer, TextFieldWrapper, SectionWrapper, InputWrapper, Input, ClearBtn } from './styles.js';
import RemoveFillIcon from '../Images/RemoveFillIcon/index.js';
import useClearBtnControl from './useClearBtnControl.js';
import getTextWidth, { getCanvasFont } from './getTextWidth.js';

var MIN_INPUT_WIDTH = 80;
function TextField(_a) {
    var id = _a.id, prefix = _a.prefix, suffix = _a.suffix, _b = _a.allowClear, allowClear = _b === void 0 ? true : _b, value = _a.value, onChange = _a.onChange, _c = _a.hasError, hasError = _c === void 0 ? false : _c, className = _a.className, _d = _a.adaptiveInputWidth, adaptiveInputWidth = _d === void 0 ? true : _d, placeholder = _a.placeholder, _e = _a.type, type = _e === void 0 ? 'text' : _e, _f = _a.isFocus, isFocus = _f === void 0 ? false : _f, _g = _a.theme, theme = _g === void 0 ? 'primary' : _g, styles = _a.styles, rest = __rest(_a, ["id", "prefix", "suffix", "allowClear", "value", "onChange", "hasError", "className", "adaptiveInputWidth", "placeholder", "type", "isFocus", "theme", "styles"]);
    /*
     * Hooks, state and refs
     * */
    var removeBtnRef = useRef(null);
    var _h = useClearBtnControl(value), isShow = _h.isShow, showClearBtn = _h.show, hiddenClearBtn = _h.hidden, status = _h.status;
    var referenceRef = useRef(null);
    var _j = useState(MIN_INPUT_WIDTH), minInputWidth = _j[0], setMinInputWidth = _j[1];
    /**
     * Handle logic and actions
     * */
    var handleChange = function (event) {
        var text = event.target.value;
        showClearBtn('focus', text);
        onChange && onChange(text);
    };
    var handleClear = function () {
        onChange && onChange('');
        hiddenClearBtn('blur');
        if (referenceRef.current) {
            referenceRef.current.focus();
        }
    };
    /**
     * Effects
     * */
    // Set adaptive width for input container
    useEffect(function () {
        if (placeholder && placeholder !== '' && adaptiveInputWidth) {
            setMinInputWidth(getTextWidth(placeholder, getCanvasFont()));
        }
    }, [placeholder, adaptiveInputWidth]);
    return (React__default.createElement(TextFieldContainer, { htmlFor: id, ref: referenceRef, onFocus: function () { return showClearBtn('focus', value); }, onBlur: function () { return hiddenClearBtn('blur'); }, onMouseEnter: function () { return showClearBtn('enter', value); }, onMouseLeave: function () { return hiddenClearBtn('leave'); }, isPointer: type === 'button' },
        React__default.createElement(TextFieldWrapper, { focus: status === 'focus' || isFocus, hasError: hasError, className: className, style: styles === null || styles === void 0 ? void 0 : styles.container, themeType: theme },
            React__default.createElement(SectionWrapper, null,
                prefix,
                React__default.createElement(InputWrapper, { minWidth: minInputWidth, isHavePlaceHolder: type === 'button' && (!value || value === ''), placeholderContent: placeholder },
                    React__default.createElement(Input, __assign({ id: id, type: type, value: value, onChange: handleChange, placeholder: placeholder, themeType: theme }, rest)),
                    allowClear && isShow ? (React__default.createElement(ClearBtn, { ref: removeBtnRef, onClick: handleClear, onMouseEnter: function () { return showClearBtn('enter-clear', value); }, onMouseLeave: function () { return hiddenClearBtn('leave-clear'); } },
                        React__default.createElement(RemoveFillIcon, null))) : null)),
            suffix)));
}

export { TextField as default };
//# sourceMappingURL=index.js.map
